<template>
  <!-- <div class="wx-main"> -->
    <div class="wx">
      <div class="wx-title">扫码下载App</div>
      <div class="wx-msg">随时随地和 HR 沟通</div>
<!--      <img src="https://files.wondercv.com/download-code/nav-bar-nuxt.png" alt="扫码下载App 随时随地和 HR 沟通">-->
      <img src="https://files.wondercv.com/pc/code/jobSearchDownload.png" alt="扫码下载App 随时随地和 HR 沟通">
      <!-- <div class="wx-msg" style="margin-top: 12px;">微信扫码 随时投递</div> -->
    </div>
  <!-- </div> -->
</template>
<script>
export default {
  name: 'wx'
}
</script>
<style lang="scss" scoped>
.wx {
  width: 100%;
  height: 291px;
  background: #fff;
  text-align: center;
  border-radius: 2px;
  overflow: hidden; // bfc
  .wx-title {
    font-size: 16px;
    font-weight: 800;
    color: #404040;
    margin-top: 30px;
  }
  .wx-msg {
    font-size: 14px;
    color: #9c9c9c;
    margin-top: 12px;
  }
  img {
    width: 160px;
    height: 160px;
    margin: 26px auto 0;
  }
}
</style>